import { tvpil } from '../../data/compat/tvpil';

export const cloudFrontConfig = {
  get baseUrl() {
    return tvpil.appStore.dms.cloudFrontUrl + '/api_v3/service';
  },

  get language() {
    return tvpil.appStore.localizationStore.appLanguage;
  },

  get partnerId() {
    return tvpil.appStore.params.dmsSetting.partnerId;
  },

  get timeout() {
    return tvpil.appStore.dms.serverTimeOut * 1000;
  },
};
